import React, {useEffect, useState} from 'react'
import moment from 'moment'
import {Tooltip} from 'react-tooltip'
import {getHistoriqueForOneDemontage, getOneDemandeDemontage} from '../../../components/requests'
import {Link, useParams} from 'react-router-dom'
import {LoadingData} from '../../../components/LoadingData'
import {DemandeDemontageDetailsHeader} from './components/DemandeDemontageDetailsHeader'

const DemandeDemontageHistoriquePage = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const [loadingHeader, setLoadingHeader] = useState<boolean>(true)
  const [data, setData] = useState<any>([])
  const [demontageData, setDemontageData] = useState<any>({})
  const params = useParams()

  const getHistory = () => {
    setLoading(true)
    getHistoriqueForOneDemontage(params?.demandeDemontageId).then((response) => {
      if (response && response.status === 200 && response?.data) {
        setData(response.data)
      }
      setLoading(false)
    })
  }

  const getInfoDemontage = () => {
    setLoadingHeader(true)
    getOneDemandeDemontage(params?.demandeDemontageId).then((response) => {
      if (response && response.status === 200 && response.data) {
        setDemontageData(response.data)
      }
      setLoadingHeader(false)
    })
  }

  useEffect(() => {
    getInfoDemontage()
    getHistory()
  }, [])

  const renderTable = () => {
    return (
      <>
        {/* begin::Row  */}
        <div className='row g-5 g-xl-8'>
          {/* begin::Col  */}
          <div className='col-lg-12 col-sm-12'>
            <div className='card card-xxl-stretch mb-5 mb-xl-8'>
              <div className='card-header border-0 d-flex align-items-center justify-content-between'>
                <div className='card-title m-0'>
                  <h3 className='fw-bolder m-0'>Historique du démontage</h3>
                </div>
                <Link
                  to={`/demande-demontage/liste`}
                  state={{}}
                  data-tooltip-id='tooltip'
                  data-tooltip-content='Revenir en arrière'
                  data-tooltip-place='right'
                >
                  <img src='/media/svg/custom/prev-arrow.svg' width={40} />
                </Link>
              </div>
              <div className='card-body py-3'>
                {/* begin::Table container */}
                <div className='table-responsive'>
                  {/* begin::Table */}
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    {/* begin::Table head */}
                    <thead>
                      <tr className='fw-bold text-muted'>
                        <th className='min-w-150px'>Changement de statut</th>
                        <th className='min-w-140px'>Date</th>
                        <th className='min-w-140px'>Utilisateur</th>
                        <th className='min-w-140px'>Commentaire</th>
                      </tr>
                    </thead>
                    {/* end::Table head */}
                    {/* begin::Table body */}
                    <tbody>
                      {data.length ? (
                        data.map((d) => {
                          return (
                            <>
                              <tr key={d.id}>
                                <td>
                                  <div className='d-flex align-items-center'>
                                    <div className='d-flex justify-content-start flex-column'>
                                      <p className='text-dark fw-semibold text-hover-primary d-block fs-6 mb-0 ms-2'>
                                        {d?.action}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <p className='text-dark fw-semibold text-hover-primary d-block fs-6 mb-0'>
                                    {moment(d?.date).format('DD/MM/YYYY HH:mm:ss')}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-semibold text-hover-primary d-block fs-6 mb-0'>
                                    {d?.utilisateur?.prenom} {d?.utilisateur?.nom}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-semibold text-hover-primary d-block fs-6 mb-0'>
                                    {d?.commentaire}
                                  </p>
                                </td>
                              </tr>
                            </>
                          )
                        })
                      ) : (
                        <tr>
                          <td colSpan={8} className='text-center'>
                            Aucun résultat trouvé
                          </td>
                        </tr>
                      )}
                    </tbody>
                    {/* end::Table body */}
                  </table>
                  {/* end::Table */}
                </div>
                {/* end::Table container */}

                {/*Affichage du tooltip*/}
                <Tooltip id='tooltip' />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <DemandeDemontageDetailsHeader
        demontageData={demontageData}
        showTypePieces={true}
        loading={loadingHeader}
      />
      {loading ? (
        <div className='card mb-5 mb-xl-10'>
          <LoadingData />
        </div>
      ) : (
        renderTable()
      )}
    </>
  )
}

export {DemandeDemontageHistoriquePage}
